import { useContext, useEffect, useState } from 'react'
import { useMatch } from '@reach/router'
import { createGroupId } from '../helpers'
import GalleryContext from '../gallery-context'

const useGalleryState = groups => {
  const { basePath } = useContext(GalleryContext)
  const match = useMatch(`/${basePath}/:groupId/*`)
  const activeGroupId = match && match['groupId']
  const activeSubgroupId = match && match['*']

  const [activeGroupName, setActiveGroupName] = useState(null)

  useEffect(() => {
    const found =
      activeGroupId && groups.find(g => createGroupId(g.name) === activeGroupId)

    setActiveGroupName(found && found.name)
  }, [groups, activeGroupId])

  return {
    activeGroupName,
    activeGroupId,
    activeSubgroupId,
  }
}

export default useGalleryState
